import React, { useState } from "react";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { ajukanIzin } from "../services/izinService";
import BottomNavbar from "../components/BottomNavbar";
import imageCompression from "browser-image-compression";

function Izin() {
  const navigate = useNavigate();
  const [jenisIzin, setJenisIzin] = useState("izin");
  const [keterangan, setKeterangan] = useState("");
  const [foto, setFoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pesan, setPesan] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1080,
        useWebWorker: true,
      };

      const compressedFile = await imageCompression(file, options);
      setFoto(compressedFile);
    } catch (error) {
      console.error("Gagal kompres gambar:", error);
      setPesan({ type: "danger", text: "Gagal memproses gambar." });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!keterangan.trim()) {
      return setPesan({ type: "danger", text: "Keterangan wajib diisi." });
    }

    if (!foto) {
      return setPesan({ type: "danger", text: "Silakan unggah foto izin." });
    }

    setLoading(true);
    const result = await ajukanIzin({ fotoFile: foto, keterangan, jenisIzin });
    setLoading(false);

    if (result.success) {
      setPesan({ type: "success", text: "Izin berhasil diajukan!" });
      setKeterangan("");
      setFoto(null);
      setJenisIzin("izin");
      setTimeout(() => navigate("/dashboard"), 1000);
    } else {
      setPesan({
        type: "danger",
        text: result.message || "Gagal mengirim izin.",
      });
    }
  };

  return (
    <Container
      style={{ minHeight: "100vh", paddingBottom: "80px" }}
      className="py-4"
    >
      <div className="d-flex align-items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "none",
            border: "none",
            fontSize: "20px",
            color: "#000",
            cursor: "pointer",
            padding: 0,
            marginRight: "12px",
          }}
        >
          ←
        </button>
        <h5 className="mb-0 fw-bold">Form Izin</h5>
      </div>

      {pesan && (
        <Alert variant={pesan.type} dismissible onClose={() => setPesan(null)}>
          {pesan.text}
        </Alert>
      )}

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Jenis Izin</Form.Label>
          <Form.Select
            value={jenisIzin}
            onChange={(e) => setJenisIzin(e.target.value)}
            className="rounded border"
          >
            <option value="sakit">Sakit (S)</option>
            <option value="izin">Izin (I)</option>
          </Form.Select>
        </Form.Group>

        <div className="mb-3">
          <Form.Label
            htmlFor="fotoIzin"
            className="d-block text-center py-3 bg-light rounded-pill text-primary"
            style={{ cursor: "pointer" }}
          >
            Ambil Foto Izin
          </Form.Label>
          <Form.Control
            type="file"
            id="fotoIzin"
            accept="image/*"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {foto && (
            <div className="text-center small mt-2 text-muted">{foto.name}</div>
          )}
        </div>

        <Form.Group className="mb-4">
          <Form.Control
            as="textarea"
            rows={4}
            placeholder="Keterangan"
            value={keterangan}
            onChange={(e) => setKeterangan(e.target.value)}
            className="rounded border"
          />
        </Form.Group>

        <Button
          type="submit"
          className="w-100 rounded-pill fw-bold"
          style={{ backgroundColor: "#2A90D9", border: "none" }}
          disabled={loading}
        >
          {loading ? "Mengirim..." : "Ajukan Izin"}
        </Button>
      </Form>

      <BottomNavbar />
    </Container>
  );
}

export default Izin;
